import React from 'react';

import { UseFormReturn } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { TICK_TYPE } from 'src/features/pricingPlan/utils/types';
import { TICK_TYPE_MAP } from 'src/features/pricingPlan/utils/constants';
import { PricingPlanCapFormSchemaValues } from 'src/features/pricingPlan/utils/formSchema';
import InputFormField from 'src/registry/components/forms/InputFormField';
import SelectFormField from 'src/registry/components/forms/SelectFormField';
import { Form, FormControl, FormControlStack, FormItem, FormLabel, FormMessage, FormField } from 'src/registry/ui/Form';
import { Input } from 'src/registry/ui/Input';
import { commonMessages } from 'src/utils/messages';

type CapFormProps = {
    form: UseFormReturn<PricingPlanCapFormSchemaValues>;
    onSubmit: (values: PricingPlanCapFormSchemaValues) => void;
};

function CapForm({ onSubmit, form }: CapFormProps) {
    const { formatMessage } = useIntl();

    const [displayRate, setDisplayRate] = React.useState('');

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <SelectFormField<PricingPlanCapFormSchemaValues>
                form={form}
                name="cap_type"
                label={formatMessage(commonMessages.type)}
                options={Object.values(TICK_TYPE)}
                optionTranslationMap={TICK_TYPE_MAP}
            />

            <InputFormField<PricingPlanCapFormSchemaValues>
                form={form}
                name="cap_minutes"
                label={formatMessage(commonMessages.minutesTitle)}
                type="number"
                placeholder={`${formatMessage(commonMessages.minutesTitle)}...`}
            />

            <FormField
                control={form.control}
                name="rate_with_tax"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            <FormattedMessage {...commonMessages.rate} />
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Input
                                    type="text"
                                    inputMode="decimal"
                                    placeholder={`${formatMessage(commonMessages.rate)}...`}
                                    value={
                                        displayRate !== ''
                                            ? displayRate
                                            : field.value != null
                                              ? (field.value / 100).toFixed(2)
                                              : ''
                                    }
                                    onChange={(e) => {
                                        const inputValue = e.target.value;

                                        if (!/^\d*\.?\d{0,2}$/.test(inputValue)) return;

                                        setDisplayRate(inputValue);

                                        const numeric = parseFloat(inputValue);
                                        if (!isNaN(numeric)) {
                                            field.onChange(Math.round(numeric * 100));
                                        } else {
                                            field.onChange(undefined);
                                        }
                                    }}
                                    onBlur={() => {
                                        if (displayRate === '' || isNaN(parseFloat(displayRate))) return;
                                        const formatted = parseFloat(displayRate).toFixed(2);
                                        setDisplayRate(formatted);
                                        field.onChange(Math.round(parseFloat(formatted) * 100));
                                    }}
                                    onKeyDown={(e) => {
                                        if (['-', '+', 'e'].includes(e.key)) e.preventDefault();
                                    }}
                                />
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
        </Form>
    );
}

export default CapForm;
